import { useDispatch } from 'react-redux';
import { fetchCatalogSearch } from '@client/catalog/redux/search/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export function useFetchCatalogSearchAction(): typeof fetchCatalogSearch {
  const dispatch = useDispatch();
  return bindActionCreators(fetchCatalogSearch, dispatch);
}
